import { useModal } from '@ebay/nice-modal-react';
import TextInput from '/src/components/UI/TextField/TextInput';
import Button from '/src/components/UI/Button/Button';
import { useForm } from 'react-hook-form';
import { useState, useRef, useEffect } from 'react';
import { DateRange } from '/src/lib/react-date-range/index.js';
import { useAnalyticsStateContext } from '../../../context/AnalyticsContext';
import AnalyticsModalDatePickerCustomDisplay from './AnalyticsModalDatePickerCustomDisplay';
import useAnalyticsModalDatePickerHook from './useAnalyticsModalDatePickerHook';
import '/src/lib/react-date-range/styles.css'; // main style file
import '/src/lib/react-date-range/theme/default.css'; // theme css file
import './AnalyticsModalDatePicker.css';
import storage from '/src/utils/storage';
// Popup use to create or modificate a variable name / type


function AnalyticsModalDatePicker( { onClose } ) {
    const modal = useModal();

    const { firstPeriod } = useAnalyticsStateContext()

    const onClick = () => { 
        modal.resolve(state)
        return onClose();
    }

    const dateRange = useRef()

    const { checkError } = useAnalyticsModalDatePickerHook(dateRange)

    const {bots} = storage('session').get('company');

    // Get the bot from url cause tired of pass him by component
    const pathsPiece = [...window.location.pathname.split("/")].filter(piece => piece);
    const botName = pathsPiece.pop();
    var bot = bots.filter(bot => bot.name == botName).pop();
    bot == bot == undefined ? {} : bot;

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() - 1)

    const minDate = new Date(bot?.created_at ?? new Date().setFullYear(new Date().getFullYear() - 10));
    //minDate.setDate(minDate.getDate() - 400)

    const startDate = new Date(firstPeriod.date_start);
    const endDate = new Date(firstPeriod.date_end);

    const [state, setState] = useState([
        {
          startDate: startDate,
          endDate: endDate,
          key: 'selection'
        }
    ]);

    
    return (
        <form className='variables_modal'>
            <label className='title'>Choose a Custom Period</label>
            <div className='area-edit'>
                <DateRange
                    editableDateInputs={true}
                    onChange={item => {
                        setState([item.selection])
                        checkError()
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                    ref={dateRange}
                    maxDate={maxDate}
                    minDate={minDate}
                    shownDate={endDate}
                    rangeColors={['#65abf61a', '#0e7aed', '#65abf61a']}
                    navigatorRenderer={AnalyticsModalDatePickerCustomDisplay}
                    dateDisplayFormat="dd/MM/yyyy"
                    direction="horizontal"
                />

            </div>
            <Button label="Confirm" onClick={onClick}/>
        </form>
    )
}

export default AnalyticsModalDatePicker;